// functions.tsx

// Definimos los tipos directamente aquí ya que no se usan en otro lugar
export interface PermissionItem {
  label: string;
  property: string;
  value: boolean;
  order: number;
}

export interface PermissionGroup {
  GrouName: string;
  Items: PermissionItem[];
}

export type PermissionsObj = { [key: string]: boolean };

// Función para transformar el objeto de permisos plano en una estructura de grupos
export const getGroupedPermissions = (permissionsObj: PermissionsObj): PermissionGroup[] => {
  const groups: PermissionGroup[] = [];

  const permissionMapping: { [key: string]: { group: string; label: string; order: number } } = {
    //#region  ÓRDENES
    Prm_Ord: { group: 'Órdenes', label: 'Ingreso al módulo', order: 1 },
    Prm_Ord_R: { group: 'Órdenes', label: 'Ver el menú izquierdo', order: 1 },
    Prm_OrdC: { group: 'Órdenes', label: 'Crear', order: 2 },
    Prm_OrdU: { group: 'Órdenes', label: 'Actualizar', order: 3 },
    Prm_OrdD: { group: 'Órdenes', label: 'Eliminar', order: 4 },
    Prm_Ord_Transfer: { group: 'Órdenes', label: 'Transferir a otros pacientes', order: 5 },
    Prm_Ord_OEr: { group: 'Órdenes', label: 'Ordenes estudios', order: 6 },
    Prm_Ord_Remisiones_Tmp: { group: 'Órdenes', label: 'Crear remisiones temporales', order: 7 },
    Prm_Ord_NotasR: { group: 'Órdenes', label: 'Modulo de notas internas', order: 8 },
    Prm_Ord_NotasC: { group: 'Órdenes', label: 'Crear notas internas', order: 9 },
    Prm_Ord_NotasU: { group: 'Órdenes', label: 'Actualizar notas internas', order: 10 },
    Prm_Ord_NotasD: { group: 'Órdenes', label: 'Eliminar notas internas', order: 11 },
    Prm_Ord_Attachments: { group: 'Órdenes', label: 'Modulo de adjuntos', order: 12 },
    Prm_Ord_Attachments_C: { group: 'Órdenes', label: 'Crear adjuntos', order: 13 },
    Prm_Ord_Attachments_D: { group: 'Órdenes', label: 'Eliminar adjuntos', order: 15 },
    Prm_Ord_ViewOtherLocation: { group: 'Órdenes', label: 'Ver órdenes de otras sedes', order: 17 },
    //#endregion

    //#region REMISIONES
    Prm_Ord_Remisiones_R: { group: 'Remisiones', label: 'Ingreso al módulo', order: 1 },
    Prm_Ord_Remisiones_C: { group: 'Remisiones', label: 'Crear', order: 2 },
    Prm_Ord_Remisiones_U: { group: 'Remisiones', label: 'Actualizar', order: 3 },
    Prm_Ord_Remisiones_D: { group: 'Remisiones', label: 'Eliminar', order: 4 },
    Prm_Ord_Remisiones_ChangeStudies: { group: 'Remisiones', label: 'Cambiar lab. ref a estudios', order: 5 },
    Prm_Ord_Remisiones_Send: { group: 'Remisiones', label: 'Enviar remisiones lab. externos.', order: 6 },
    //#endregion
    
    //#region  RESULTADOS
    Prm_Res: { group: 'Resultados', label: 'Ingreso al módulo', order: 1 },
    Prm_ResC: { group: 'Resultados', label: 'Ingresar Resultados', order: 2 },
    Prm_ResValidar: { group: 'Resultados', label: 'Validar Resultados', order: 3 },
    Prm_ResValMasivo: { group: 'Resultados', label: 'Validación Masiva de Resultados', order: 4 },
    Prm_ResDesvalidar: { group: 'Resultados', label: 'Desvalidar Resultados', order: 4 },
    Prm_ResClarear: { group: 'Resultados', label: 'Clarear Resultados', order: 5 },
    Prm_ResImprimir: { group: 'Resultados', label: 'Imprimir Resultados', order: 6 },
    Prm_Res_Retransmitir: { group: 'Resultados', label: 'Retransmitir Resultados', order: 7 },
    Prm_Res_Preview: { group: 'Resultados', label: 'Vista Previa de Resultados', order: 10 },
    Prm_Res_Mail: { group: 'Resultados', label: 'Enviar Resultados por Correo', order: 11 },
    Prm_Res_WhatsApp: { group: 'Resultados', label: 'Enviar Resultados por WhatsApp', order: 12 },
    Prm_Res_Conf: { group: 'Resultados', label: 'Puede ver Resultados confidenciales', order: 12 },
    Prm_Res_Val_Crit: { group: 'Resultados', label: 'Validación Resultados críticos', order: 13 },
    Prm_Res_Val_OtrSd: { group: 'Resultados', label: 'Validación Resultados de otras sedes', order: 14 },
    Prm_Res_InVal_OtrSd: { group: 'Resultados', label: 'Desvalidar Resultados de otras sedes', order: 15 },
    Prm_Ord_Attachments_Val: { group: 'Resultados', label: 'Validar examenes como adjuntos', order: 16 },
    Prm_Res_DelAn: { group: 'Resultados', label: 'Eliminar Analitos', order: 17 },
    //#endregion

    //#region  CODIGOS DE BARRAS
    Prm_CodBarrras: { group: 'Códigos de barras', label: 'Ingreso al módulo', order: 1 },
    Prm_CodBarBuscar: { group: 'Códigos de barras', label: 'Buscar', order: 2 },
    Prm_CodBarImprimir: { group: 'Códigos de barras', label: 'Imprimir', order: 3 },
    //#endregion

    //#region  BUSQUEDA
    Prm_Busqueda: { group: 'Búsquedas', label: 'Módulo de busquedas', order: 1 },
    Prm_BusquedaOrdenes: { group: 'Búsquedas', label: 'Módulo de órdenes', order: 2 },
    Prm_BusquedaPacientes: { group: 'Búsquedas', label: 'Módulo de pacientes', order: 3 },
    //#endregion

    //#region BACKUPS
    Prm_BackUp_R: { group: 'Backups', label: 'Ver Backups generados', order: 1 },
    Prm_BackUp_Down: { group: 'Backups', label: 'Descargar Backups', order: 1 },
    Prm_BackUp_C: { group: 'Backups', label: 'Crear Backups', order: 1 },
    Prm_BackUp_D: { group: 'Backups', label: 'Eliminar Backups', order: 1 },
    //#endregion

    //#region  IMPRESION MASIVA
    Prm_Imprimir: { group: 'Impresión masiva', label: 'Ingreso al módulo', order: 1 },
    //Prm_ImprBuscar: { group: 'Impresión masiva', label: 'Buscar', order: 2 },
    //Prm_ImprImp: { group: 'Impresión masiva', label: 'Imprimir', order: 3 },
    //#endregion

    //#region  Reportes
    Prm_Inf: { group: 'Reportes', label: 'Ingreso al módulo', order: 3 },
    //#region

    //#region MONITOREO
    Prm_Monitoreo: { group: 'Monitoreo', label: 'Ingreso al módulo', order: 1 },
    //#endregion

    //#region ANALIZADOR
    Prm_Analizador: { group: 'Analizadores', label: 'Ingreso al módulo', order: 1 },
    //#endregion

    //#region PACIENTE
    Prm_Pac: { group: 'Paciente', label: 'Ingreso al módulo', order: 1 },
    Prm_PacC: { group: 'Paciente', label: 'Crear', order: 2 },
    Prm_PacU: { group: 'Paciente', label: 'Actualizar', order: 3 },
    Prm_PacD: { group: 'Paciente', label: 'Eliminar', order: 4 },
    //#endregion

    //#region CONFIGURACION
    Prm_Conf: { group: 'Configuración', label: 'Menú configuración', order: 1 },
    Prm_Conf_Manejo: { group: 'Configuración', label: 'Configuración general', order: 2 },
    Prm_ConfPerm: { group: 'Configuración', label: 'Configuración de permisos', order: 3 },
    Prm_ConfTablas: { group: 'Configuración', label: 'Mantenimientos', order: 4 },
    Prm_Conf_Campos: { group: 'Configuración', label: 'Definiciones', order: 5 },
    Prm_Conf_Barcode_Imp: { group: 'Configuración', label: 'Impresoras de Códigos de Barras', order: 6 },
    Prm_Conf_Reportes: { group: 'Configuración', label: 'Configuración de Reportes', order: 7 },
    Prm_Conf_Usuario: { group: 'Configuración', label: 'Configuración de Usuarios', order: 7 },
    Prm_Conf_Estudio: { group: 'Configuración', label: 'Configuración de Estudio', order: 8 },
    Prm_Est_C: { group: 'Configuración', label: 'Crear Estudio', order: 9 },
    Prm_Est_U: { group: 'Configuración', label: 'Actualizar Estudio', order: 10 },
    Prm_Est_D: { group: 'Configuración', label: 'Eliminar Estudio', order: 11 },
    Prm_Conf_Analito: { group: 'Configuración', label: 'Configuración de Analito', order: 12 },
    Prm_An_C: { group: 'Configuración', label: 'Crear Analito', order: 13 },
    Prm_An_U: { group: 'Configuración', label: 'Actualizar Analito', order: 14 },
    Prm_An_D: { group: 'Configuración', label: 'Eliminar Analito', order: 15 },
    Prm_Config_Citas: { group: 'Configuración', label: 'Configuración de Citas', order: 17 },
    Prm_Config_Facturacion: { group: 'Configuración', label: 'Configuración de Facturación', order: 18 },
    Prm_Conf_Usuario_GenToken: { group: 'Configuración', label: 'Generar Token de Usuario', order: 19 },
    Prm_Conf_AnalitoPlantillas: { group: 'Configuración', label: 'Plantillas predeterminadas de Analito', order: 20 },    
    //#endregion

    //#region COTIZACIONES Y FACTURACION
    Prm_Fact: { group: 'Facturación', label: 'Ingreso al módulo', order: 1 },
    Prm_Cotizaciones: { group: 'Facturación', label: 'Cotizaciones', order: 1 },
    Prm_Cotizaciones_R: { group: 'Facturación', label: 'Consultar cotizaciones', order: 2 },
    Prm_Cotizaciones_C: { group: 'Facturación', label: 'Crear cotizaciones', order: 3 },
    Prm_Cotizaciones_U: { group: 'Facturación', label: 'Actualizar cotizaciones', order: 4 },
    Prm_Cotizaciones_D: { group: 'Facturación', label: 'Eliminar cotizaciones', order: 5 },
    Prm_FactCaja: { group: 'Facturación', label: 'Caja', order: 6 },
    Prm_FactCajaLiquidar: { group: 'Facturación', label: 'Liquidar caja', order: 7 },
    Prm_FactCaja_U: { group: 'Facturación', label: 'Actualizar caja', order: 8 },
    Prm_FactFEVRIPS: { group: 'Facturación', label: 'Ver FEV/RIPS', order: 9 },
    Prm_FactFEVRIPS_C: { group: 'Facturación', label: 'Generar FEV/RIPS', order: 10 },
    //#endregion

    //#region PAGINA WEB RESULTADOS
    Prm_PagWebRes_Config: { group: 'Página Web Resultados', label: 'Ver Configuración', order: 1 },
    Prm_PagWebRes_Config_General: { group: 'Página Web Resultados', label: 'Config. General', order: 2 },
    Prm_PagWebRes_Usuarios_R: { group: 'Página Web Resultados', label: 'Ver Usuarios', order: 3 },
    Prm_PagWebRes_Usuarios_C: { group: 'Página Web Resultados', label: 'Crear Usuario', order: 4 },
    Prm_PagWebRes_Usuarios_U: { group: 'Página Web Resultados', label: 'Actualizar Usuario', order: 5 },
    Prm_PagWebRes_Usuarios_D: { group: 'Página Web Resultados', label: 'Eliminar Usuario', order: 6 },
    Prm_PagWebRes_Usuarios_ChangePass: { group: 'Página Web Resultados', label: 'Cambiar contraseñas', order: 7 },
    //#endregion

    //#region EXTERNOS
    Prm_ExtDbConex: { group: 'Externos', label: 'Obtener Conexión a base de datos', order: 1 },
    Prm_ExtReportR: { group: 'Externos', label: 'Obtener Reporte', order: 2 },
    Prm_ExtReportC: { group: 'Externos', label: 'Crear Reporte', order: 3 },
    Prm_ExtReportU: { group: 'Externos', label: 'Actualizar Reporte', order: 4 },
    Prm_ExtReportD: { group: 'Externos', label: 'Eliminar Reporte', order: 5 },
    Prm_External_Views: { group: 'Externos', label: 'Ver Vistas, Solo para interfaces', order: 6 },
    Prm_External_ResR: { group: 'Externos', label: 'Ver Resultados, apps e interfaces externas', order: 7 },
    Prm_External_ResC: { group: 'Externos', label: 'Agregar Resultados, apps e interfaces externas', order: 8 },
    Prm_External_Exceptions: { group: 'Externos', label: 'Registrar Excepciones, apps e interfaces externas', order: 9 },
    Prm_External_Rem: { group: 'Externos', label: 'Crear y recibir Remisiones externas', order: 10 },
    //#endregion

    //#region CITAS
    Prm_Citas: { group: 'Citas', label: 'Ingreso al módulo', order: 1 },
    Prm_Citas_C: { group: 'Citas', label: 'Crear', order: 2 },
    Prm_Citas_U: { group: 'Citas', label: 'Actualizar', order: 3 },
    Prm_Citas_D: { group: 'Citas', label: 'Eliminar', order: 4 },
    Prm_Citas_R: { group: 'Citas', label: 'Consultar', order: 5 },
    Prm_Citas_R_Todas: { group: 'Citas', label: 'Consultar todas las agendas', order: 6 },
    //#endregion

    //#region  PREORDENES
    Prm_Preordenes: { group: 'Preórdenes', label: 'Ingreso al módulo', order: 1 },
    Prm_Preordenes_C: { group: 'Preórdenes', label: 'Crear', order: 2 },
    Prm_Preordenes_U: { group: 'Preórdenes', label: 'Actualizar', order: 3 },
    Prm_Preordenes_D: { group: 'Preórdenes', label: 'Eliminar', order: 4 },
    Prm_Preordenes_R: { group: 'Preórdenes', label: 'Consultar', order: 5 },
    Prm_Preordenes_Notas_R: { group: 'Preórdenes', label: 'Consultar Notas', order: 6 },
    Prm_Preordenes_Notas_C: { group: 'Preórdenes', label: 'Crear Notas', order: 7 },
    Prm_Preordenes_Notas_U: { group: 'Preórdenes', label: 'Actualizar Notas', order: 8 },
    Prm_Preordenes_Notas_D: { group: 'Preórdenes', label: 'Eliminar Notas', order: 9 },
    //#endregion

    //#region OTROS
    Prm_CamPass: { group: 'Otros', label: 'Puede cambiar la contraseña', order: 1 },
    Prm_AccDir: { group: 'Otros', label: 'Accesos directos', order: 1 },
    Prm_External: { group: 'Otros', label: 'Acceso al módulo Sist. Externos', order: 1 },
    //#endregion

    //#region  MUEUSTRAS
    Prm_Ord_Tracking_R: { group: 'Muestras', label: 'Ingreso al módulo de tracking', order: 1 },
    Prm_Ord_Tracking_U: { group: 'Muestras', label: 'Hacer trackings de muestras', order: 2 },
    //#endregion

    //#region CONSENTIMIENTOS
    Prm_Conf_Consentimientos: { group: 'Consentimientos', label: 'Configuración de Consentimientos', order: 1 },
    Prm_Ord_Consentimientos_R: { group: 'Consentimientos', label: 'Consultar consentimientos', order: 2 },
    Prm_Ord_Consentimientos_C: { group: 'Consentimientos', label: 'Crear consentimientos', order: 3 },
    Prm_Ord_Consentimientos_U: { group: 'Consentimientos', label: 'Actualizar consentimientos', order: 4 },
    //#endregion

    //#region CONTROL DE CALIDAD
    Prm_Config_QC: { group: 'Control de Calidad', label: 'Configuración de Control de Calidad', order: 1 },
    Prm_QC: { group: 'Control de Calidad', label: 'Ingreso al módulo', order: 1 },
    Prm_QC_C: { group: 'Control de Calidad', label: 'Crear control de calidad', order: 2 },
    Prm_QC_R: { group: 'Control de Calidad', label: 'Consultar control de calidad', order: 3 },
    Prm_QC_U: { group: 'Control de Calidad', label: 'Actualizar control de calidad', order: 4 },
    Prm_QC_D: { group: 'Control de Calidad', label: 'Eliminar control de calidad', order: 5 },
    Prm_QC_Validar: { group: 'Control de Calidad', label: 'Validar control de calidad', order: 6 },
    Prm_QC_Informes: { group: 'Control de Calidad', label: 'Acceso a Informes (Levey-Jennings / Westgard)', order: 7 },
    Prm_QC_InformesSigma: { group: 'Control de Calidad', label: 'Informes Sigma (requiere Acceso a Informes)', order: 8 },
    Prm_QC_EditLater: { group: 'Control de Calidad', label: 'Editar control de calidad posterior a la validación', order: 9 },
    //#endregion

    //#region  REMISIONES EXTERNAS
    Prm_ExternalRem: { group: 'Remisiones Externas', label: 'Ingreso al módulo', order: 1 },
    Prm_ExternalRem_Config: { group: 'Remisiones Externas', label: 'Configuración', order: 2 },
    Prm_ExternalRem_U: { group: 'Remisiones Externas', label: 'Actualizar remisiones', order: 4 },
    Prm_ExternalRem_D: { group: 'Remisiones Externas', label: 'Eliminar remisiones', order: 5 },
    Prm_ExternalRem_I: { group: 'Remisiones Externas', label: 'Importar remisiones', order: 3 },
    Prm_ExternalRem_E: { group: 'Remisiones Externas', label: 'Exportar remisiones', order: 6 },
    //#endregion

    //#region EDITOR SQL
    Prm_SqlEditor: { group: 'Editor SQL', label: 'Ingreso al módulo (consultas)', order: 1 },
    Prm_SqlEditorWrite: { group: 'Editor SQL', label: 'Edición estructurada por Id (grid)', order: 2 },
    Prm_SqlEditorRaw: { group: 'Editor SQL', label: 'Ejecutar SQL crudo (UPDATE/DELETE/INSERT)', order: 3 },
    Prm_SqlEditorAudit: { group: 'Editor SQL', label: 'Ver auditoría', order: 4 },
    Prm_SqlEditorAdmin: { group: 'Editor SQL', label: 'Administrar token/QR', order: 5 },
    //#endregion
  };

  // Recorrer todos los permisos y agruparlos según su grupo y etiqueta
  for (const [key, value] of Object.entries(permissionsObj)) {
    const { group, label, order } = permissionMapping[key] || {};

    if (group) {
      let groupFound = groups.find((g) => g.GrouName === group);

      if (!groupFound) {
        groupFound = { GrouName: group, Items: [] };
        groups.push(groupFound);
      }

      groupFound.Items.push({
        label: label || key, // Si no se encuentra la etiqueta, usa el nombre de la propiedad
        property: key,
        value: value,
        order: order || 0, // Añadimos el orden si no existe
      });
    }
  }

  // Ahora ordenamos los permisos dentro de cada grupo
  groups.forEach((group) => {
    group.Items.sort((a, b) => a.order - b.order);
  });

  return groups;
};
